import { EditCourseCategoryPage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/edit/$courseDraftId/$categoryId')({
  component: EditCourseCategoryPageComponent
});

function EditCourseCategoryPageComponent() {
  const { categoryId, courseDraftId } = Route.useParams();

  return <EditCourseCategoryPage categoryId={categoryId} courseDraftId={courseDraftId} />;
}
